import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ThemeSettings = () => {
  const [formData, setFormData] = useState({
    color_primary_1: '#F7F1ED',
    color_primary_2: '#BCB3A3',
    color_primary_3: '#136E93',
    color_primary_4: '#023A56',
    color_primary_5: '#142439',
    color_sec_1: '#E9DBB6',
    color_sec_2: '#FFEBAE',
    color_sec_3: '#EC8845',
    // --- NOVOS CAMPOS DE FONTE ADICIONADOS AQUI ---
    font_primary: '',
    font_secondary: '',
    font_terciary: '',
    whatsapp_number: '',
    wp_blog_url: '',
    social_instagram: '',
    social_facebook: '',
    social_youtube: '',
    company_address: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Busca as configurações atuais
  useEffect(() => {
    api.get('/settings')
      .then(res => {
        setFormData(prev => ({ ...prev, ...res.data }));
      })
      .catch(err => console.error("Erro ao carregar configurações", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await api.put('/admin/settings', formData);
      setMessage('Configurações atualizadas com sucesso!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error(err);
      setMessage('Erro ao salvar as configurações.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card shadow-sm border-0 mb-5">
      <div className="card-header bg-white py-3">
        <h5 className="mb-0 fw-bold">Aparência e Configurações Globais</h5>
      </div>
      <div className="card-body p-4">
        {message && (
          <div className={`alert ${message.includes('Erro') ? 'alert-danger' : 'alert-success'}`}>
            {message}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          {/* CORES PRINCIPAIS */}
          <h6 className="fw-bold mb-3 border-bottom pb-2">Paleta de Cores Principais</h6>
          <div className="row mb-4">
            {[1, 2, 3, 4, 5].map(num => (
              <div className="col-md-2 mb-3" key={`prim_${num}`}>
                <label className="form-label small text-muted">Cor {num}</label>
                <input 
                  type="color" className="form-control form-control-color w-100 border-0 p-1 shadow-sm" 
                  name={`color_primary_${num}`} value={formData[`color_primary_${num}`] || '#000000'} onChange={handleChange}
                />
                <div className="text-center mt-1 small text-uppercase fw-bold text-muted">{formData[`color_primary_${num}`]}</div>
              </div>
            ))}
          </div>

          {/* CORES DE APOIO */}
          <h6 className="fw-bold mb-3 border-bottom pb-2">Paleta de Cores Secundárias</h6>
          <div className="row mb-5">
            {[1, 2, 3].map(num => (
              <div className="col-md-2 mb-3" key={`sec_${num}`}>
                <label className="form-label small text-muted">Apoio {num}</label>
                <input 
                  type="color" className="form-control form-control-color w-100 border-0 p-1 shadow-sm" 
                  name={`color_sec_${num}`} value={formData[`color_sec_${num}`] || '#000000'} onChange={handleChange}
                />
                <div className="text-center mt-1 small text-uppercase fw-bold text-muted">{formData[`color_sec_${num}`]}</div>
              </div>
            ))}
          </div>

          {/* --- NOVA SEÇÃO: TIPOGRAFIA --- */}
          <h6 className="fw-bold mb-3 border-bottom pb-2">Tipografia (Google Fonts)</h6>
          <div className="row mb-5">
            <div className="col-md-4 mb-3">
              <label className="form-label small fw-bold text-muted">Fonte Primária (Títulos)</label>
              <input 
                type="text" className="form-control" name="font_primary"
                value={formData.font_primary || ''} onChange={handleChange}
                placeholder="Ex: Cinzel"
              />
              <div className="form-text small">Digite o nome exato como aparece no Google Fonts.</div>
            </div>
            
            <div className="col-md-4 mb-3">
              <label className="form-label small fw-bold text-muted">Fonte Secundária (Destaques)</label>
              <input 
                type="text" className="form-control" name="font_secondary"
                value={formData.font_secondary || ''} onChange={handleChange}
                placeholder="Ex: Carattere"
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label small fw-bold text-muted">Fonte Terciária (Textos Básicos)</label>
              <input 
                type="text" className="form-control" name="font_terciary"
                value={formData.font_terciary || ''} onChange={handleChange}
                placeholder="Ex: Montserrat"
              />
            </div>
          </div>

          <div className="row">
            {/* COLUNA ESQUERDA: INFORMAÇÕES GERAIS E INTEGRAÇÕES */}
            <div className="col-md-6 mb-4 pe-md-4">
              <h6 className="fw-bold mb-3 border-bottom pb-2">Informações Gerais e Integrações</h6>
              
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  <i className="bi bi-geo-alt-fill me-2 text-warning"></i>
                  Endereço do Empreendimento
                </label>
                <input 
                  type="text" 
                  className="form-control" 
                  name="company_address"
                  value={formData.company_address || ''} 
                  onChange={handleChange}
                  placeholder="Ex: Alameda César Nascimento, 700. Jurerê..."
                />
                <div className="form-text small">
                  Este endereço geral aparecerá no rodapé (Footer) do site.
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label small fw-bold"><i className="bi bi-whatsapp me-2 text-success"></i>Número do WhatsApp</label>
                <input 
                  type="text" className="form-control" name="whatsapp_number"
                  value={formData.whatsapp_number || ''} onChange={handleChange}
                  placeholder="Ex: 5548999999999 (Apenas números)"
                />
                <div className="form-text small">Usado para os botões flutuantes e links de contato rápidos.</div>
              </div>

              <div className="mb-3 p-3 bg-light rounded border mt-4">
                <label className="form-label small fw-bold"><i className="bi bi-wordpress me-2 text-info"></i>URL do Blog (WordPress API)</label>
                <input 
                  type="url" className="form-control bg-white" name="wp_blog_url"
                  value={formData.wp_blog_url || ''} onChange={handleChange}
                  placeholder="Ex: https://seusite.com/wp-json/wp/v2/posts"
                />
                <div className="form-text small">Caminho da API para a seção dinâmica de notícias puxar os últimos posts.</div>
              </div>
            </div>

            {/* COLUNA DIREITA: REDES SOCIAIS */}
            <div className="col-md-6 mb-4 ps-md-4 border-start">
              <h6 className="fw-bold mb-3 border-bottom pb-2">Redes Sociais</h6>
              
              <div className="mb-3">
                <label className="form-label small fw-bold"><i className="bi bi-instagram me-2 text-danger"></i>Link do Instagram</label>
                <input 
                  type="url" className="form-control" name="social_instagram"
                  value={formData.social_instagram || ''} onChange={handleChange}
                  placeholder="https://instagram.com/seu_perfil"
                />
              </div>

              <div className="mb-3">
                <label className="form-label small fw-bold"><i className="bi bi-facebook me-2 text-primary"></i>Link do Facebook</label>
                <input 
                  type="url" className="form-control" name="social_facebook"
                  value={formData.social_facebook || ''} onChange={handleChange}
                  placeholder="https://facebook.com/sua_pagina"
                />
              </div>

              <div className="mb-3">
                <label className="form-label small fw-bold"><i className="bi bi-youtube me-2 text-danger"></i>Link do YouTube</label>
                <input 
                  type="url" className="form-control" name="social_youtube"
                  value={formData.social_youtube || ''} onChange={handleChange}
                  placeholder="https://youtube.com/@seu_canal"
                />
              </div>
            </div>
          </div>

          <div className="border-top pt-4 mt-2 text-end">
            <button type="submit" className="btn btn-dark px-5 py-2 fw-bold" disabled={loading}>
              {loading ? 'SALVANDO...' : 'SALVAR CONFIGURAÇÕES'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ThemeSettings;